import { FunctionComponent, Suspense, useEffect } from 'react';
import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';
import ConsentContextProvider from './components/Flow/ConsentContextProvider';
import ConsentLayout from './components/Flow/ConsentLayout';
import Loading from './components/Loading/Loading';
import AnalyticsProvider from './components/Analytics/AnalyticsProvider';
import ErrorBoundary from './components/Error/ErrorBoundary';
import TranslationProvider from './components/Translations/TranslationProvider';
import { RelayProvider } from './components/Providers/RelayProvider';
import FeatureGateProvider from './components/FeatureGates/FeatureGateProvider';
import { AccountClientProvider } from './definitions/user';

export const App: FunctionComponent = () => {
  useEffect(() => {
    setGlobalTheme().catch((e) => console.warn('Theme failed to load', e));
  }, []);

  return (
    <AccountClientProvider>
      <TranslationProvider>
        <AnalyticsProvider loading={<Loading />}>
          <ErrorBoundary>
            <ConsentContextProvider loading={<Loading />}>
              <FeatureGateProvider>
                <RelayProvider>
                  <Suspense fallback={<Loading />}>
                    <ConsentLayout />
                  </Suspense>
                </RelayProvider>
              </FeatureGateProvider>
            </ConsentContextProvider>
          </ErrorBoundary>
        </AnalyticsProvider>
      </TranslationProvider>
    </AccountClientProvider>
  );
};
